module.exports = __webpack_public_path__ + "static/img/barra_12.a3eefe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_12.png
// module id = MAxm
// module chunks = 1